import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
@Component({
    selector: 'app-whatsapp-messages',
    templateUrl: './whatsapp-messages.component.html',
    styleUrls: ['./whatsapp-messages.component.css'],
    standalone: false
})
export class WhatsappMessagesComponent implements OnInit {
  refreshQR = false;
  isrefreshQR: boolean = false;
  countDown: number = 15;
  countdownTimerWP: any;
  countdownWP: number = 15;
  counter: number = 0;
  qrCodeMessage = `If not connected refresh QR in 15 seconds...`;
  qrCodeImage: string;
  isConnected: boolean = false;
  previewData: any[] = [];
  messageText: string = '';
  selectedFile: File;
  MessageForm!: FormGroup;
  gridState: DataSourceRequestState = {
    skip: 0,
    take: 10
  };
  isLoading: boolean = false;

  // New state
  currentView: 'campaigns' | 'messages' = 'campaigns';
  showAddCampaignModal: boolean = false;
  campaignsList: any[] = [];
  totalCampaigns: number = 0;
  selectedCampaign: any = null;
  campaignFormVisible: boolean = false;
  searchTerm: string = '';
  campaignsGridData: GridDataResult = { data: [], total: 0 };
  previewGridData: GridDataResult = { data: [], total: 0 };


  constructor(private readonly loaderService: LoaderService, private readonly api: ApiService,
    private readonly toaster: ToastrService, private readonly FormBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.CheckConnection()
    this.LoadForm();
    this.loadCampaigns();
  }

  LoadForm() {
    this.MessageForm = this.FormBuilder.group({
      CampaignName: ['', [Validators.required]],
      StartDate: [new Date(), [Validators.required]],
      EndDate: [new Date(), [Validators.required]],
      Message: ['', Validators.required],
      DailyLimit: [100],
      MinTimeGapMinutes: [1],
      RandomExtraMinutes: [1],
    });
  }


  CheckConnection() {
    this.refreshQR = true;
    this.loaderService.show();

    this.api.checkWhatsAppConnection('00000_1').subscribe({
      next: (newRes: any) => {
        this.isConnected = newRes?.isConnected === true;
        if (this.isConnected) {
          this.stopCountdown();
          this.qrCodeImage = '';
          this.loaderService.hide();
          return;
        }
        this.generateQR();

        this.loaderService.hide();
      },
      error: () => {
        this.loaderService.hide();
      }
    });
  }

  generateQR() {
    this.api.generateWhatsAppQR('00000_1').subscribe((res: any) => {
      this.qrCodeImage = res?.qr;
      this.startCountdown();
    });
  }

  startCountdown() {
    this.stopCountdown();
    this.countdownWP = 15;

    this.countdownTimerWP = setInterval(() => {
      this.countdownWP--;
      this.qrCodeMessage =
        `If not connected QR will refresh in ${this.countdownWP} seconds...`;

      if (this.countdownWP <= 0) {
        this.stopCountdown();
        this.CheckConnection();
      }

    }, 1000);
  }

  stopCountdown(): void {
    if (this.countdownTimerWP) {
      clearInterval(this.countdownTimerWP);
      this.countdownTimerWP = null;
    }
  }

  logoutSession() {
    this.loaderService.show();
    this.api.logoutWhatsAppSession('00000_1').subscribe({
      next: (res: any) => {
        console.log('Logout response:', res);

        this.stopCountdown();
        this.qrCodeImage = '';
        this.CheckConnection();

        this.loaderService.hide();
      },
      error: (err: any) => {
        console.error('Logout error:', err);
        this.loaderService.hide();
      }
    });
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];

    if (!validTypes.includes(file.type)) {
      this.toaster.error('Only Excel file (.xls / .xlsx) allowed');
      event.target.value = '';
      return;
    }

    this.selectedFile = file;
  }

  resetForm() {
    this.MessageForm.reset();
    this.selectedFile = null as any;
    // Clear the file input element manually
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  uploadFile() {
    if (this.MessageForm.invalid) {
      this.MessageForm.markAllAsTouched();
      this.toaster.error('Please fill all required fields');
      return;
    }
    if (!this.selectedFile) {
      this.toaster.error('Please select a file first');
      return;
    }

    this.loaderService.show();
    const { CampaignName, EndDate, Message } = this.MessageForm.value;

    this.api.importBulkMessage(this.selectedFile, CampaignName, EndDate, Message).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res.Success) {
          this.previewData = res.Data;
        } else {
          this.toaster.error(res.Message ?? 'Failed to import records');
        }
      },
      error: (err: any) => {
        this.loaderService.hide();
        this.toaster.error('Error importing file');
      }
    });
  }

  openAddCampaign() {
    this.resetForm();
    this.previewData = [];
    this.campaignFormVisible = true;
  }

  saveCampaign() {
    if (this.MessageForm.invalid) {
      this.MessageForm.markAllAsTouched();
      this.toaster.error('Please fill all required fields');
      return;
    }
    if (!this.selectedFile) {
      this.toaster.error('Please select a file first');
      return;
    }

    this.loaderService.show();
    const formValues = this.MessageForm.value;

    this.api.saveCampaignWithMessages(this.selectedFile, formValues).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res.Success) {
          this.toaster.success('Campaign saved successfully');
          this.campaignFormVisible = false;
          this.loadCampaigns();
        } else {
          this.toaster.error(res.Message ?? 'Failed to save campaign');
        }
      },
      error: (err) => {
        this.loaderService.hide();
        this.toaster.error('Error saving records');
      }
    });
  }

  saveMessage() {
    if (this.MessageForm.invalid) {
      this.MessageForm.markAllAsTouched();
      this.toaster.error('Please fill all required fields');
      return;
    }
    if (!this.selectedFile) {
      this.toaster.error('Please select a file first');
      return;
    }

    this.loaderService.show();
    const { CampaignName, EndDate, Message } = this.MessageForm.value;

    this.api.importAndSaveBulkMessage(this.selectedFile, CampaignName, EndDate, Message).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res.Success) {
          this.toaster.success('All records saved successfully');
          // Refresh the grid from the database to show finalized records
          this.loadGridData();
          this.resetForm(); 
        } else {
          this.toaster.error(res.Message ?? 'Failed to save records');
        }
      },
      error: (err) => {
        this.loaderService.hide();
        this.toaster.error('Error saving records');
      }
    });
  }

  onSearch(): void {
    this.gridState.skip = 0;
    if (this.currentView === 'campaigns') {
      this.loadCampaigns();
    } else {
      this.loadGridData();
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.onSearch();
  }

  onDataStateChangeCampaigns(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.loadCampaigns();
  }

  onDataStateChangeMessages(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.loadGridData();
  }

  onCellClick(event: any) {
    // Detect double click using the original mouse event detail (click count)
    if (event.originalEvent && event.originalEvent.detail === 2) {
      this.viewCampaignMessages(event.dataItem);
    }
  }

  loadCampaigns() {
    this.loaderService.show();
    this.api.getCampaigns(this.gridState, this.searchTerm).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res.Success) {
          this.campaignsList = res.Data;
          this.totalCampaigns = res.Total ?? res.Data?.length ?? 0;
          this.campaignsGridData = { data: this.campaignsList, total: this.totalCampaigns };
        }
      },
      error: (err: any) => {
        this.loaderService.hide();
        console.error('Error loading campaigns:', err);
      }
    });
  }

  viewCampaignMessages(campaign: any) {
    this.selectedCampaign = campaign;
    this.currentView = 'messages';
    this.gridState = { skip: 0, take: 10 };
    this.loadGridData();
  }

  backToCampaigns() {
    this.currentView = 'campaigns';
    this.selectedCampaign = null;
    this.searchTerm = '';
    this.gridState = { skip: 0, take: 10 };
    this.loadCampaigns();
  }

  loadGridData() {
    if (!this.selectedCampaign) return;
    
    this.loaderService.show();
    this.api.getBulkMessagesByCampaign(this.selectedCampaign.Id, this.gridState).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res.Success) {
          this.previewData = res.Data;
          this.previewGridData = { data: this.previewData, total: res.Total ?? res.Data?.length ?? 0 };
        }
      },
      error: (err: any) => {
        this.loaderService.hide();
        console.error('Error loading messages:', err);
      }
    });
  }
}
